import Loading from './Loading';

export default Loading;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/Loading/index.js